// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UiBP","toggle":"styles_toggle__iqfZM","preview":"styles_preview___qHV4"};